// We must disable SSR to ensure the PDf worker works correctly

import { getPaperPdfUrl } from "helpers/api";
import dynamic from "next/dynamic";
import { useEffect, useMemo, useState } from "react";
import { PaperQuote } from "store/slices/citedPapers";
import FloatingQuoteSelector from "./FloatingQuoteSelector";

// https://github.com/wojtekmaj/react-pdf?tab=readme-ov-file#configure-pdfjs-worker
const PDFViewer = dynamic(() => import("components/PDFViewer"), {
  ssr: false,
});

type PaperPDFTabProps = {
  paperId: string;
  title: string;
  selectedQuoteIndex?: number;
  quotes?: PaperQuote[];
  citation?: number;
  onLoadError?: () => void;
};

function PaperPDFTab({
  paperId,
  title,
  selectedQuoteIndex,
  quotes = [],
  citation,
  onLoadError,
}: PaperPDFTabProps) {
  // Local state for currently selected quote index
  const [currentQuoteIndex, setCurrentQuoteIndex] = useState<
    number | undefined
  >(selectedQuoteIndex);

  // Update currentQuoteIndex when selectedQuoteIndex prop changes
  useEffect(() => {
    setCurrentQuoteIndex(selectedQuoteIndex);
  }, [selectedQuoteIndex]);

  const paperPdfUrl = useMemo(() => {
    return getPaperPdfUrl(paperId);
  }, [paperId]);

  const selectedQuoteObj =
    currentQuoteIndex !== undefined ? quotes[currentQuoteIndex] : undefined;
  const currentQuote = selectedQuoteObj?.quote || "";

  return (
    <div className="h-full">
      <PDFViewer
        url={paperPdfUrl}
        title={title}
        highlight={currentQuote}
        showControls={false}
        onLoadError={onLoadError}
      />

      {/* Floating QuoteSelector */}
      {quotes.length > 0 && (
        <FloatingQuoteSelector
          quotes={quotes}
          selectedQuote={currentQuoteIndex}
          onSelectQuote={setCurrentQuoteIndex}
          citation={citation}
        />
      )}
    </div>
  );
}

export default PaperPDFTab;
